import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vModelText as _vModelText, withModifiers as _withModifiers, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a38df513"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nge-fb-shell" }
const _hoisted_2 = {
  ref: "fxCanvas",
  class: "nge-fb-fx",
  "aria-hidden": "true"
}
const _hoisted_3 = {
  key: 0,
  class: "nge-fb-body"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-fb-title" }, "Submit an issue", -1 /* HOISTED */))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-fb-hint" }, "Found a bug or have an idea? Tell us — it goes straight to the team.", -1 /* HOISTED */))
const _hoisted_6 = { class: "nge-fb-chips" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "nge-fb-attach" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Attach my current view, a share link so the team sees exactly what I see", -1 /* HOISTED */))
const _hoisted_10 = {
  key: 0,
  class: "nge-fb-err"
}
const _hoisted_11 = { class: "nge-fb-actions" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = {
  key: 1,
  class: "nge-fb-done holoscan holo-on"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "holoscan-line",
  "aria-hidden": "true"
}, null, -1 /* HOISTED */))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-fb-done-icon" }, "✓", -1 /* HOISTED */))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-fb-done-text" }, "Thanks — your report was sent.", -1 /* HOISTED */))
const _hoisted_17 = [
  _hoisted_14,
  _hoisted_15,
  _hoisted_16
]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock($setup["ModalOverlay"], {
    id: "nge-feedback-modal",
    class: "nge-feedback-modal",
    onHide: _cache[8] || (_cache[8] = $event => ($setup.emit('hide')))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("canvas", _hoisted_2, null, 512 /* NEED_PATCH */),
        _createElementVNode("button", {
          class: "nge-fb-exit",
          onClick: _cache[0] || (_cache[0] = $event => ($setup.emit('hide')))
        }, "×"),
        (!$setup.done)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _hoisted_4,
              _hoisted_5,
              _createElementVNode("div", _hoisted_6, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.CATEGORIES, (c) => {
                  return _createElementVNode("button", {
                    key: c,
                    class: _normalizeClass(["nge-fb-chip", { 'nge-fb-chip--active': $setup.category === c }]),
                    onClick: $event => ($setup.category = c)
                  }, _toDisplayString(c), 11 /* TEXT, CLASS, PROPS */, _hoisted_7)
                }), 64 /* STABLE_FRAGMENT */))
              ]),
              _withDirectives(_createElementVNode("textarea", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($setup.message) = $event)),
                class: "nge-fb-note",
                rows: "4",
                placeholder: "What happened? What did you expect? Steps to reproduce help a lot.",
                onKeydown: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"])),
                onKeyup: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"])),
                onKeypress: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"])),
                onInput: _cache[5] || (_cache[5] = $event => ($setup.error = ''))
              }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                [_vModelText, $setup.message]
              ]),
              _createElementVNode("label", _hoisted_8, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => (($setup.attachView) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelCheckbox, $setup.attachView]
                ]),
                _hoisted_9
              ]),
              ($setup.error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString($setup.error), 1 /* TEXT */))
                : _createCommentVNode("v-if", true),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("button", {
                  class: "nge-fb-submit",
                  disabled: $setup.sending,
                  onClick: $setup.submit
                }, _toDisplayString($setup.sending ? 'Sending…' : 'Submit'), 9 /* TEXT, PROPS */, _hoisted_12),
                _createElementVNode("button", {
                  class: "nge-fb-cancel",
                  onClick: _cache[7] || (_cache[7] = $event => ($setup.emit('hide')))
                }, "Cancel")
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_17))
      ])
    ]),
    _: 1 /* STABLE */
  }))
}